export interface CameraCapability {
  open(options: MediaStreamConstraints): Promise<MediaStream>
  stop(stream: MediaStream): void
}

export class WebCamera implements CameraCapability {
  open(options: MediaStreamConstraints): Promise<MediaStream> { return navigator.mediaDevices.getUserMedia(options) }
  stop(stream: MediaStream): void { for (const track of stream.getTracks()) track.stop() }
}
